export { selfDescriptionsEn } from './en';
export { selfDescriptionsSk } from './sk';
export { selfDescriptionsCz } from './cz';

// Helper function to get self descriptions by language
import { selfDescriptionsEn } from './en';
import { selfDescriptionsSk } from './sk';
import { selfDescriptionsCz } from './cz';

export function getSelfDescriptions(lang: 'sk' | 'en' | 'cz') {
  switch (lang) {
    case 'sk':
      return selfDescriptionsSk;
    case 'en':
      return selfDescriptionsEn;
    case 'cz':
      return selfDescriptionsCz;
    default:
      return selfDescriptionsSk; // fallback to Slovak
  }
}